import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=5c079944&scoped=true&"
import script from "./ReviewCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&id=5c079944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c079944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c079944')) {
      api.createRecord('5c079944', component.options)
    } else {
      api.reload('5c079944', component.options)
    }
    module.hot.accept("./ReviewCard.vue?vue&type=template&id=5c079944&scoped=true&", function () {
      api.rerender('5c079944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCard.vue"
export default component.exports